/* ══════════════════════════════════════════════════════════════════════════
   Variantes de portada por campaña de Google Ads
   ──────────────────────────────────────────────────────────────────────────
   Quien busca "me despidieron injustificadamente" y aterriza en un título que
   dice "Derecho Laboral" no reconoce su problema: ahí se rompe el hilo entre
   el anuncio y la página. Cada campaña trae un parámetro ?t= en su URL final
   y la página muestra el bloque que le corresponde.

   Sin parámetro —tráfico orgánico— se muestra el texto general de siempre, y
   el canonical de cada página apunta a la ruta limpia, así que las variantes
   no generan contenido duplicado.

   URLS FINALES CONFIGURADAS EN GOOGLE ADS:
     Despido Injustificado  → /areas/derecho-laboral?t=despido
     Pensión de Alimentos   → /areas/derecho-familia?t=pension
     Divorcio               → /areas/derecho-familia?t=divorcio
     Posesión Efectiva      → /areas/derecho-civil?t=posesion

   El grupo de "cuánto me corresponde por despido" no usa variante: va a la
   calculadora, que responde la pregunta en vez de ofrecer una consulta.
     Cálculo de finiquito    → /calculadora-finiquito

   PARA EDITAR EL TEXTO: cambiar aquí abajo, nada más. El contenido jurídico
   debe revisarlo una abogada antes de publicarse.

   No se usa inserción automática de la palabra clave a propósito: pega en el
   titular lo que la persona escribió, faltas de ortografía incluidas.
   ══════════════════════════════════════════════════════════════════════════ */

import type { VarianteAnuncio } from '../types';

export const VARIANTES: Record<string, VarianteAnuncio> = {
  despido: {
    area: 'laboral',
    titulo: '¿Te despidieron sin causa justificada?',
    bajada: 'Si el despido se declara injustificado, tu indemnización aumenta con un recargo legal.',
    plazo: 'Tienes 60 días hábiles desde el despido para demandar.',
    chips: ['Despido injustificado', 'Finiquito mal pagado', 'Necesidades de la empresa', 'Autodespido'],
    mensaje: 'Hola, me despidieron y quiero saber si el despido fue justificado. ¿Pueden revisar mi caso?',
  },
  pension: {
    area: 'familia',
    titulo: '¿Necesitas fijar, aumentar o cobrar una pensión de alimentos?',
    bajada: 'Hoy existen herramientas de cobro reales: retención de la devolución de impuestos y el Registro Nacional de Deudores. Te decimos cuáles aplican a tu caso.',
    chips: ['Fijar pensión', 'Aumento', 'Cobro de deuda', 'Registro de deudores'],
    mensaje: 'Hola, necesito ayuda con una pensión de alimentos. ¿Pueden orientarme?',
  },
  divorcio: {
    area: 'familia',
    titulo: '¿Quieres divorciarte y no sabes por dónde empezar?',
    bajada: 'El plazo y el procedimiento cambian según si hay acuerdo o no. En una conversación te decimos cuál te corresponde y cuánto demora.',
    chips: ['De común acuerdo', 'Unilateral', 'Compensación económica', 'Cuidado personal'],
    mensaje: 'Hola, quiero iniciar un divorcio y necesito saber qué procedimiento me corresponde.',
  },
  posesion: {
    area: 'civil',
    titulo: '¿Necesitas tramitar una posesión efectiva?',
    bajada: 'Con testamento se tramita en tribunales; sin testamento, en el Registro Civil. El camino, los plazos y el costo son distintos.',
    chips: ['Sin testamento', 'Con testamento', 'Bienes raíces', 'Impuesto a la herencia'],
    mensaje: 'Hola, necesito tramitar una posesión efectiva. ¿Pueden ayudarme?',
  },
};
